module.exports = __webpack_public_path__ + "img/anatomy.55289380.svg";